import { createAsyncThunk } from '@reduxjs/toolkit';

import type { UserControllerMeResponse } from '~/api';
import { userControllerMe } from '~/api';
import { getErrorMessage } from '~/utils/api';

export const me = createAsyncThunk<UserControllerMeResponse, undefined, { rejectValue: string }>(
  'user/me',
  async (_data, { rejectWithValue }) => {
    try {
      const response = await userControllerMe();

      if (response.error) {
        return rejectWithValue(getErrorMessage(response.error));
      }

      if (!response.data.success) {
        return rejectWithValue('general.generalErrorMsg');
      }

      return response.data;
    } catch (e) {
      return rejectWithValue((e as Error).message);
    }
  }
);
